import { AccountItemBlock, AccountItemLine } from "./AccountItem";
import {
  ExportSOAPKeyInfoToggle,
  ExportSOAPSignalmentToggle,
  PageSaverToggle,
} from "./ExportToggles";
import FeatureToggle from "./FeatureToggle";

export default function LegacySettings() {
  return (
    <div id="legacySection" className="flex-1 flex flex-col gap-md">
      <AccountItemLine dataTestId="legacy-settings-line">
        <FeatureToggle
          title="Use Typed Notes"
          description="This setting enables Typed Notes and Typed Templates, which some of our earliest customers still rely on. If you don't know what this is, you probably don't need to enable it. 😉"
          flagKey="useLegacyNotes"
          segmentKey="legacy-notes-users"
        />
      </AccountItemLine>
      <AccountItemBlock
        title="Include Key Info:"
        desc="Toggling this will
                include key information in SOAP note PDF exports."
      >
        <ExportSOAPKeyInfoToggle />
      </AccountItemBlock>

      <AccountItemBlock
        title="Include Patient Info:"
        desc="Toggling this
                will include patient signalment and contact info in
                your SOAP note PDF exports."
      >
        <ExportSOAPSignalmentToggle />
      </AccountItemBlock>

      <AccountItemBlock
        title="Page Saver:"
        desc="Toggling this setting OFF
                will put each note on a separate page when exporting entire notebooks."
      >
        <PageSaverToggle />
      </AccountItemBlock>
    </div>
  );
}
